export default "/crvUSD-USDT.684dae28c3fb9a9726feec0df297f0df.png";